import Vue from 'vue'
import VueRouter from 'vue-router'
import Campaigns from '../pages/Campaigns'
import CampaignsAll from '../pages/CampaignsAll'
import CampaignsDrafts from '../pages/CampaignsDrafts'
import CampaignsTesting from '../pages/CampaignsTesting'
import CampaignsPending from '../pages/CampaignsPending'
import CampaignsApproved from '../pages/CampaignsApproved'
import CampaignsRejected from '../pages/CampaignsRejected'
import CampaignsSent from '../pages/CampaignsSent'
import CampaignDetails from '../pages/CampaignDetails'
import CampaignDetailsSummary from '../pages/CampaignDetailsSummary'
import CampaignDetailsPreview from '../pages/CampaignDetailsPreview'
import CampaignDetailsTesting from '../pages/CampaignDetailsTesting'
import CampaignDetailsAudience from '../pages/CampaignDetailsAudience'
import CampaignDetailsHistory from '../pages/CampaignDetailsHistory'
import CampaignDetailsReport from '../pages/CampaignDetailsReport'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/campaigns',
    name: 'Home',
    component: Campaigns
  },
  {
    path: '/campaigns',
    redirect: '/campaigns/all',
    name: 'Campaigns',
    component: Campaigns,
    meta: { page: 'campaigns' },
    children: [
      {
        path: 'all',
        name: 'CampaignsAll',
        component: CampaignsAll,
        meta: { page: 'campaigns' }
      },
      {
        path: 'drafts',
        name: 'CampaignsDrafts',
        component: CampaignsDrafts,
        meta: { page: 'campaigns' }
      },
      {
        path: 'testing',
        name: 'CampaignsTesting',
        component: CampaignsTesting,
        meta: { page: 'campaigns' }
      },
      {
        path: 'pending',
        name: 'CampaignsPending',
        component: CampaignsPending,
        meta: { page: 'campaigns' }
      },
      {
        path: 'approved',
        name: 'CampaignsApproved',
        component: CampaignsApproved,
        meta: { page: 'campaigns' }
      },
      {
        path: 'rejected',
        name: 'CampaignsRejected',
        component: CampaignsRejected,
        meta: { page: 'campaigns' }
      },
      {
        path: 'sent',
        name: 'CampaignsSent',
        component: CampaignsSent,
        meta: { page: 'campaigns' }
      }
    ]
  },
  {
    path: '/campaign-details/',
    redirect: '/campaign-details/summary',
    name: 'CampaignDetails',
    component: CampaignDetails,
    meta: { page: 'details' },
    children: [
      {
        path: 'summary',
        name: 'CampaignDetailsSummary',
        component: CampaignDetailsSummary,
        meta: { page: 'details' }
      },
      {
        path: 'preview',
        name: 'CampaignDetailsPreview',
        component: CampaignDetailsPreview,
        meta: { page: 'details' }
      },
      {
        path: 'testing',
        name: 'CampaignDetailsTesting',
        component: CampaignDetailsTesting,
        meta: { page: 'details' }
      },
      {
        path: 'audience',
        name: 'CampaignDetailsAudience',
        component: CampaignDetailsAudience,
        meta: { page: 'details' }
      },
      {
        path: 'history',
        name: 'CampaignDetailsHistory',
        component: CampaignDetailsHistory,
        meta: { page: 'details' }
      },
      {
        path: 'report',
        name: 'CampaignDetailsReport',
        component: CampaignDetailsReport,
        meta: { page: 'details' }
      }
    ]
  },
  {
    path: '*',
    name: 'catchAll',
    redirect: '/campaigns/all',
    component: Campaigns
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.afterEach((to, from) => {
  if (to.meta.page === 'details' && from.meta.page === 'campaigns') {
    store.commit('SET_LANDING_TAB', from.name)
  }
  window.localStorage.setItem('LS_ROUTE', to.path)
})

let isFirstTransition = true
router.beforeEach((to, from, next) => {
  let shouldRedirect = false
  // const entries = performance.getEntriesByType('navigation') navigation entries are not recognized in safari
  let lsRoute = localStorage.getItem('LS_ROUTE')
  let campaignId = null
  if (lsRoute) {
    for (const [key, value] of (new URLSearchParams(window.location.search)).entries()) {
      if (key === 'campaignId') {
        campaignId = value
      }
    }
    if (lsRoute.startsWith('/campaign-details')) {
      lsRoute = campaignId ? lsRoute : null
    }
  }
  if (to.name === 'CampaignsAll' && lsRoute && lsRoute !== '/campaigns/all' && isFirstTransition) {
    shouldRedirect = true
  }
  isFirstTransition = false
  if (shouldRedirect) {
    next({ path: localStorage.getItem('LS_ROUTE'), query: to.query })
  } else {
    next()
  }
})

// router.replace({ path: '/campaigns/all', redirect: '/campaigns' })

export default router
